"use client";
import classNames from "classnames";
import { HasAdContext } from "components/framework/AdContextWrapper";
import { ICommonAppData } from "lib/types/sanity";
import { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import styles from "./AdnuntiusAd.module.css";


//#region [Props]
type AdnuntiusAdProps = {
    appData: ICommonAppData,
    index: number,
    className?: string;
    hideOnMobile: boolean;
    hideOnDesktop?: boolean;
    debugLabel?: string;
    showAdAfterFirstScroll?: boolean;
};
//#endregion

//#region [Component]
export default function AdnuntiusAd({ appData, index, className, hideOnMobile, hideOnDesktop = false, debugLabel, showAdAfterFirstScroll = false }: AdnuntiusAdProps) {

    const [isLarge, setIsLarge] = useState<boolean | null>(null);
    const [isVisible, setIsVisible] = useState(!showAdAfterFirstScroll);
    const hasAdContext = useContext(HasAdContext);
    const [ref, isInViewport] = useInView({ threshold: 0.5 });

    useEffect(() => {
        // in case the useState initializer for isLarge fires before window is available
        setIsLarge(testIsLarge());
    }, [])

    useEffect(() => {
        //console.debug("showAdAfterFirstScroll", showAdAfterFirstScroll, "hideOnMobile", hideOnMobile, "isLarge", isLarge);
        if (showAdAfterFirstScroll === true && hideOnMobile === false && isLarge === false) {
            const onFirstScroll = () => {
                setIsVisible(true);
                window.removeEventListener("scroll", onFirstScroll);

            };

            window?.addEventListener("scroll", onFirstScroll);

            return () => window?.removeEventListener("scroll", onFirstScroll);
        }
    }, [showAdAfterFirstScroll, isLarge, hideOnMobile]);

    if ((appData?.settings?.adIds?.length ?? 0) <= index) {
        console.debug(`${debugLabel ? `[${debugLabel}] ` : ""}No ad for index ${index}`, appData?.settings?.adIds);
        return null;
    }

    // use explicit === false and === true to prevent null from doing anything
    if (isLarge === null || (hideOnMobile && isLarge === false) || (hideOnDesktop && isLarge === true)) {
        return null;
    }

    return <div className={classNames(styles.AdContainer, hasAdContext[index] ? null : styles.AdContainer_hasNoAd, className)} data-debuglabel={debugLabel}>
        <div className={styles.EmptyAdPlaceholder} ref={ref}>
            {(isVisible || isLarge || isInViewport) && <div className={styles.AdElement} id={appData.settings!.adIds![index].adPlacementName}></div>}
        </div>
    </div>;
}
//#endregion

function testIsLarge(): boolean | null {
    if (typeof window !== "undefined" && window?.["matchMedia"]) {
        const mql = window.matchMedia("(min-width: 641px)")
        return mql.matches;
    }
    return null;
}